// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"02ba0810","983":"f54239d3"}[chunkId] + ".chunk.js";
};